import {
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';
import { AudienceDto, AudienceMode } from 'app/shared/apis/product/model/audienceDto';

export interface NamedRef { id?: string; name?: string; memberIds?: string[] }

// SESSION-admin-ptg-003 — `.aud-badge` (everyone-green ✓ / N teams / N groups /
// single-named-group). Inputs accept optional team/group lookups so a single
// known team or group renders as a name pill instead of a count pill.
@Component({
    selector: 'app-audience-badge',
    templateUrl: './audience-badge.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class AudienceBadgeComponent {
    @Input() audience: AudienceDto | null | undefined;
    @Input() teamLookup: ReadonlyArray<NamedRef> | null = null;
    @Input() groupLookup: ReadonlyArray<NamedRef> | null = null;

    get isEveryone(): boolean {
        const a = this.audience;
        if (!a) {
            return true;
        }
        if (a.mode === AudienceMode.Everyone) {
            return true;
        }
        const t = (a.teamIds || []).length;
        const g = (a.groupIds || []).length;
        return t === 0 && g === 0;
    }

    get label(): string {
        if (this.isEveryone) {
            return 'Everyone';
        }
        const teams = this.audience?.teamIds || [];
        const groups = this.audience?.groupIds || [];
        // Single team — show the name if we have it.
        if (teams.length === 1 && groups.length === 0) {
            const t = this.teamLookup?.find((x) => x.id === teams[0]);
            if (t?.name) {
                return t.name;
            }
            return '1 team';
        }
        // Single group — show the name if we have it.
        if (groups.length === 1 && teams.length === 0) {
            const g = this.groupLookup?.find((x) => x.id === groups[0]);
            if (g?.name) {
                return g.name;
            }
            return '1 group';
        }
        if (teams.length > 0 && groups.length === 0) {
            return `${teams.length} teams`;
        }
        if (groups.length > 0 && teams.length === 0) {
            return `${groups.length} groups`;
        }
        return `${teams.length + groups.length} groups`;
    }
}
